<template>
  <div>
 


  
    <Header :sale="sale" :links="links" />
  <el-tabs :tab-position="tabPosition" style="min-height: 300px;">
    <el-tab-pane label="Details"> <Information class="sales__section" :proposal_matched_quote="sale.proposal_matched_quote" />
   </el-tab-pane>
    <el-tab-pane label="Create Invoice">
      <SaleWorkingFilesSummary class="sales__section" :sale_id="sale.id"  v-if="parent_sale.invoice_based_wf"  />
      <EditForm :lists="lists" :is_manager="show_conditions.is_manager"
          :is_additional_invoice="show_conditions.is_additional_invoice" :is_schedule="show_conditions.is_schedule"
          :proposal_matched_quote="sale.proposal_matched_quote" /></el-tab-pane>
          <el-tab-pane label="Raised Invoices"><DescriptionsList :show_conditions="show_conditions" /> </el-tab-pane>   
    <el-tab-pane label="Job Description"> <JobDesc class="sales__section" v-if="show_conditions.is_job_desc" :job_desc="sale.job_desc" />
    </el-tab-pane>
    <el-tab-pane label="Job Notes"> <JobNotes class="sales__section" v-if="show_conditions.is_job_notes" :proposal_id="sale.proposal_id" /></el-tab-pane>
    <el-tab-pane label="Task Time"> <TaskTimeSpents class="sales__section" v-if="sale.proposal_id" :proposal_id="sale.proposal_id" /></el-tab-pane>
  
  </el-tabs>
 
       
       
       
     
   
  </div>
</template>

<script>

import { sale_store } from "store/modules/sale_store";
import { mapGetters, mapActions } from "vuex";

import Header from "./sales_form_elements/Header";
import Information from "./sales_form_elements/Information"
import EditForm from "./sales_form_elements/EditForm";
import DescriptionsList from "./sales_form_elements/DescriptionsList"
import ScheduleElements from "./sales_form_elements/ScheduleElements";
import JobDesc from "./sales_form_elements/JobDesc";
import JobNotes from "./sales_form_elements/JobNotes";
import TaskTimeSpents from "./task_time_spents/TaskTimeSpents";

import SaleWorkingFilesSummary from "./sales_form_elements/SaleWorkingFilesSummary";

export default {
  name: "SalesEditForm",
  store: sale_store,
  components: {
    TaskTimeSpents,
    Header,
    Information,
    EditForm,
    DescriptionsList,
    ScheduleElements,
    JobDesc,
    JobNotes,
    SaleWorkingFilesSummary,
    
  },
  props: ["sale", "links", "lists", "show_conditions"],
    data() {
      return {
        tabPosition: 'left'
      };
   
  },
  created() {
    const {
      scheduled_item, client_name, job_name, quote_type, proposal_matched_quote, job_desc,
      ...parent_sale
    } = {
      ...this.sale,
      ...{
        send_invoice: this.sale.send_invoice || false,
        job_no: this.sale.job_no ? this.sale.job_no : this.sale.proposal_id
      }
    }
    this.parent_sale = parent_sale;

    this.parent_sale.wf_sales.forEach(wf_sale => {
      this.add_sale({
        key: wf_sale.id,
        sale: wf_sale
      });
    });

    if (this.parent_sale.invoice_based_wf == true) {
      this.set_current_sale_key(this.parent_sale.wf_sales[0].id);
    }
  },
  computed: {
    ...mapGetters([
      "get_parent_sale",
    ]),
    parent_sale: {
      get() {
        return this.get_parent_sale;
      },
      set(value) {
        this.set_parent_sale(value);
      }
    }
  },
  methods: {
    ...mapActions([
      'set_parent_sale',
      'add_sale',
      'set_current_sale_key'
    ])
  }
}
</script>
